import * as React from 'react'

import Bullet from 'main/components/school/common/Bullet'
import InfoSection from 'main/components/school/common/InfoSection'
import { DollarSignIcon, Link } from 'main/ui'

interface IProps {
  onClickTuitionInfo: () => void
}

export default function Tuition({ onClickTuitionInfo }: IProps) {
  return (
    <InfoSection title="Tuition">
      <Bullet icon={<DollarSignIcon />}>
        <Link to="#" onClick={onClickTuitionInfo}>
          Request pricing
        </Link>
      </Bullet>
    </InfoSection>
  )
}
